import {Directive} from '@angular/core';

@Directive({
    selector: '[dialog-content], dialog-content, [dialogContent]',
    host: {
        '[style.display]': '"block"',
        '[style.max-height]': '"60vh"',
        '[style.overflow]': '"auto"',
    },
    standalone: false
})
export class DialogContentDirective {

  constructor() { }

}
